import React, { Component } from 'react'
import { Container } from 'components/Layout'
import Button from 'components/Button'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import LinedTable from 'components/Tables/LinedTable/LinedTable'

export default class RatesModal extends Component {
  render() {
    const { modalConfirm, rates } = this.props

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Detailed Rates</div>
          <br />
          {rates.data.map(item => [
            <div key="title" className={cn(sText.descrip2, sMarg.mb20)}>
              {item.label}
            </div>,
            <LinedTable key="table" className={sMarg.mb30}>
              {item.items.map(rate => (
                <div key={rate.label}>
                  <div>{rate.label}:</div>
                  <div>{rate.value}</div>
                </div>
              ))}
            </LinedTable>,
          ])}
          <div className={cn(sText.descrip3, sMarg.mt30)} style={{ whiteSpace: 'pre-wrap' }}>
            {rates.notes}
          </div>
          <div className={cn(sLay['layout-column'], sLay['layout-align-start-center'])}>
            <Button onClick={modalConfirm} plain className={sMarg.mt30}>
              Cancel
            </Button>
          </div>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/RatesModal/RatesModal.jsx